/**
 * @fileoverview Details for a given entity.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */
import {EntityInfo} from '/src/com/yext/listingslaunchstorm/js/data/entityinfo';

import * as styles from '/src/com/yext/listingslaunchstorm/js/components/styles/entitydetails.module.scss';
import EntityPinpointSvg from '/src/com/yext/listingslaunchstorm/public/icons/entity-pinpoint.svg';

/**
 * Details for a given entity.
 * @param {{
 *  entity: EntityInfo,
 * }} props
 * @return {React.ReactNode}
*/
export const EntityDetails = ({entity}) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <EntityPinpointSvg/>
      </div>
      <div className={styles.details}>
        <ul>
          <li>{entity.name}</li>
          {entity.addressTokens.map((addressToken, index) =>
            <li key={`addressToken-${index}`}>{addressToken}</li>,
          )}
          <li>{entity.phone}</li>
        </ul>
      </div>
    </div>
  );
};
